import { Glyphicon } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';

import SelectField from 'components/forms/selectField/SelectField';
import Tooltip from 'components/tooltip/Tooltip';
import { TriggerType } from 'models/automation/Triggers';
import { orderBy } from 'utils/arrayUtils';
import { TriggerAddEditModalFormValues } from './TriggerAddEditModal.schema';
import { LeftAlignedTooltipContent } from './TriggerAddEditModal.styles';

const TriggerAddEditModalTriggerTypeField = () => {
  const { t } = useTranslation();
  const { setValue } = useFormContext<TriggerAddEditModalFormValues>();

  const triggerTypeOptions = Object.values(TriggerType).map((value) => ({
    label: t('pageAutomations.triggers.triggerType', { context: value }),
    value,
  }));

  const options = [
    { label: t('pageAutomations.triggers.triggerType'), value: '' },
    ...orderBy(triggerTypeOptions, [{ field: 'label', order: 'asc' }]),
  ];

  const handleTriggerTypeChange = () => {
    setValue('eventType', '');
  };

  return (
    <SelectField
      colSmInput={12}
      label={
        <>
          {t('pageAutomations.triggers.modal.triggerType')}
          <Tooltip
            id="triggerType-tooltip"
            placement="right"
            text={
              <LeftAlignedTooltipContent>
                <Trans
                  i18nKey="pageAutomations.triggers.modal.triggerTypeTooltip"
                  components={{ ul: <ul />, li: <li /> }}
                />
              </LeftAlignedTooltipContent>
            }
          >
            <Glyphicon
              glyph="info-sign"
              id="triggerType-tooltip-icon"
              data-testid="triggerType-tooltip-icon"
            />
          </Tooltip>
        </>
      }
      labelOnTop
      name="triggerType"
      onChangeHandler={handleTriggerTypeChange}
      options={options}
      required
    />
  );
};

export default TriggerAddEditModalTriggerTypeField;
